/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workflow_Add_TriggerInputs */

const cs_workflow_add_trigger = /** @type {(inputs: Workflow_Add_TriggerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přidat spouštěč`)
};

const en_workflow_add_trigger = /** @type {(inputs: Workflow_Add_TriggerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add trigger`)
};

/**
* | output |
* | --- |
* | "Add trigger" |
*
* @param {Workflow_Add_TriggerInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const workflow_add_trigger = /** @type {((inputs?: Workflow_Add_TriggerInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workflow_Add_TriggerInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_workflow_add_trigger(inputs)
	return cs_workflow_add_trigger(inputs)
});